export * from './WeChatIcon'
